import React from 'react';
import { Button } from 'react-bootstrap';
import ClipLoader from 'react-spinners/ClipLoader';

const ButtonRequest = ({ title, titleLoading, handlerFn, isButtonDisabled, isLoading }) => {
  return (
    <Button
      variant="primary"
      size="lg"
      className="mx-0"
      // className="me-2 w-auto ms-2 mb-2 d-flex justify-content-between align-items-center"
      onClick={() => handlerFn()}
      disabled={isButtonDisabled}
      style={{ height: '36px' }}
    >
      {isLoading && <ClipLoader disabled={isButtonDisabled} color="#FFFFFF" loading={isLoading} size={10} />}
      {isLoading ? titleLoading : title}
    </Button>
  );
};
export default ButtonRequest;
